import React from 'react'

import { MAX_ROOM_LIMIT } from 'constants/offer'
import { connect } from 'react-redux'
import TextLink from 'components/Luxkit/TextLink'
import SolidPlusIcon from 'components/Luxkit/Icons/solid/SolidPlusIcon'
import Caption from 'components/Luxkit/Typography/Caption'
import { pluralizeToString } from 'lib/string/pluralize'
import { getSupportContact } from 'selectors/supportContactSelector'
import { rem } from 'polished'
import styled from 'styled-components'
import { mediaQueryUp } from 'components/utils/breakpoint'

const TextLinkContainer = styled.div`
  padding: ${rem(16)} ${rem(20)};

  ${mediaQueryUp.tablet} {
    padding: 0;
  }
`

interface Props {
  className?: string;
  contactNumber?: App.GeoContact;
  onClick?: (e: React.MouseEvent<HTMLAnchorElement>) => void;
  roomsCount: number;
  saleUnit?: string;
  maxRooms?: number;
  noServiceContact?: boolean;
}

function AddRoomButton(props: Props) {
  const {
    className,
    contactNumber,
    onClick,
    roomsCount,
    saleUnit,
    maxRooms = MAX_ROOM_LIMIT,
    noServiceContact,
  } = props
  const unit = saleUnit || 'room'
  const pluralizeSaleUnit = pluralizeToString(unit, maxRooms)

  return (
    <div className={className} data-testid="add-room-button">
      {roomsCount < maxRooms &&
        <TextLinkContainer>
          <TextLink size="medium" startIcon={<SolidPlusIcon />} onClick={onClick}>
            Add another {unit}
          </TextLink>
        </TextLinkContainer>
      }
      {(roomsCount >= maxRooms && !noServiceContact && contactNumber) &&
        <Caption variant="medium" weight="bold">
          <>
            For bookings of more than {pluralizeSaleUnit} please contact our customer service team on{' '}
            <TextLink href={`tel:${contactNumber.number}`} rel="nofollow">
              {contactNumber.humanReadable}
            </TextLink>.
          </>
        </Caption>
      }
    </div>
  )
}

function mapStateToProps(state: App.State) {
  return {
    contactNumber: getSupportContact(state).defaultContact,
  }
}

export default connect(mapStateToProps)(AddRoomButton)
